module.exports = function(bh) {
  bh.match('fast-buy', function(ctx) {
    ctx.attrs({
      'data-id': '101047',
      'data-available-price': '610 ',
      'data-available-name': 'Bona mente! крем детский 50мл питательный',
      'data-manufacturer': 'ЗАО ЗЕЛЕНАЯ ДУБРАВА',
      'data-vendor-code': 'Арт. 124332',
      'data-available-image': '//dummyimage.com/80x80/',
    });
  });
};
